<template>
  <div class="dorm-tab__left mycursorPointer ">
    <div v-on:click="goPageAll()"
      v-if="$route.params.type || $route.params.faculty" class="dorm-tab__button">
      <span class="button__wrp">
        <span class="dorm-tab__txt">
          See<literal>All </literal>
        </span>
      </span>
    </div>
    <div v-on:click="goPage(tab)"
      class="dorm-tab__button mycursorPointer"
      v-for="tab in tabs" :key="tab.id"
      :class="[{ active : tab.typeID === checkGender }, tab.cat ]">
        <span class="button__wrp">
          <span class="dorm-tab__icon">
            <img :src="tab.icon" alt="" class="icon">
          </span>
          <span class="dorm-tab__txt">
            <span v-html="tab.title">{{tab.title}}</span>
          </span>
        </span>
    </div>
  </div>
</template>

<script>
import Utiliy from '../../common'
export default {
  name: 'DormTabNavBranch',
  props: {
    tabs: Array
  },
  data () {
    return {
      showGenderButtons: true,
      branchedDormTitle: '',
      currentTab: null
    }
  },
  methods: {
    select (tab) {
      this.currentTab = tab
    },
    string_to_slug (str) {
      return Utiliy.string_to_slug(str)
    },
    goPageAll() {
      window.localStorage.setItem('dormGender', '')  
      const dorm = Utiliy.string_to_slug(this.branchedDormTitle)
      const route = { name: 'Branch', params: { dorm: dorm} }
      this.$router.push(route)
    },    
    goPage(tab) {
      
      const dorm = Utiliy.string_to_slug(this.branchedDormTitle)
      let gender = 'erkek'
      if(tab.typeID === 2 ) {
        gender = 'kiz'
      }
      window.localStorage.setItem('dormGender', gender)
      window.localStorage.setItem('gender', gender)

      let route = { name: 'BranchGender', params: { dorm: dorm, type: gender} }
          if (this.$route.params.district) {
          route = { name: 'BranchDistrictGender', params: { district:this.$route.params.district, type: gender } }
        }
      this.$router.push(route)
    },
    generateUrl (tab) {
      let route
      if (tab.typeID === 1) {
        if (this.$route.params.faculty) {
          route = { name: 'StudioProductGenre', params: { type: 'erkek' } }
        } else {
          route = { name: 'StudioProduct', params: { type: 'erkek' } }
        }
      } else if (tab.typeID === 2) {
        if (this.$route.params.faculty) {
          route = { name: 'StudioProductGenre', params: { type: 'kiz' } }
        } else {
          route = { name: 'StudioProduct', params: { type: 'kiz' } }
        }
      }
      return route
    },
    clearFilter () {
      // this.$router.push({ name: 'City', params: { slug: this.$route.params.slug } })
      this.currentTab = null
    }
  },
  computed: {
    checkGender () {
      let typeID
      if (this.$route.params.type === 'erkek') {
        typeID = 1
      } else if (this.$route.params.type === 'kiz') {
        typeID = 2
      }
      return typeID
    }
  },
  created() {
    this.branchedDormTitle = window.localStorage.getItem('branchedDormTitle')
    
    const slug = window.localStorage.getItem('slug')

    if(slug.includes('-kiz-') && slug.includes('-erkek-')) {
      let b = 5
  }      
    else if(slug.includes('-kiz-') || slug.includes('-erkek-')) {
      this.showGenderButtons = false
  }  
}
}
</script>

<style scoped>
  .mycursorPointer { 
    cursor: pointer; 
    }
</style>
